import { SHELL, WHITE_LABEL } from '../lib/branding.ts';

/**
 * 로고 — liveGPT 는 랜딩(livegpt.co.kr)과 같은 심볼·워드마크. 어두운 바탕이면 워드마크를 흰색으로.
 * 화이트라벨은 대행사 로고 이미지, 없으면 서비스 이름 글자(워드마크 폰트는 liveGPT 글자만 담은 서브셋이라 쓰지 않는다)
 */
export function LogoMark({ tone, size = 'md' }: { tone: 'onDark' | 'onLight'; size?: 'sm' | 'md' }) {
  if (WHITE_LABEL) {
    return SHELL.logoPath ? (
      <img
        src={SHELL.logoPath}
        alt={SHELL.serviceName}
        referrerPolicy="no-referrer"
        className={size === 'sm' ? 'h-6 w-auto' : 'h-8 w-auto'}
      />
    ) : (
      <span
        className={`font-bold font-suit leading-none ${size === 'sm' ? 'text-[20px]' : 'text-[24px]'} ${
          tone === 'onDark' ? 'text-white' : 'text-live'
        }`}
      >
        {SHELL.serviceName}
      </span>
    );
  }
  return (
    <span role="img" className="inline-flex items-center gap-2" aria-label={SHELL.serviceName}>
      <svg
        viewBox="0 0 226 333"
        aria-hidden="true"
        className={size === 'sm' ? 'h-6 w-auto shrink-0' : 'h-8 w-auto shrink-0'}
      >
        <path
          fill="var(--color-live)"
          fillRule="evenodd"
          d="M71.4 0H154l71.4 333h-89.7V189.4a22.8 22.8 0 0 0-45.6 0V333H0ZM112.4 79.7a22.8 22.8 0 0 1 22.8 22.8v3.5a22.8 22.8 0 0 1-45.6 0v-3.5a22.8 22.8 0 0 1 22.8-22.8Z"
        />
      </svg>
      <span
        aria-hidden="true"
        className={`-translate-y-px font-bold font-wordmark leading-none ${size === 'sm' ? 'text-[22px]' : 'text-[28px]'} ${
          tone === 'onDark' ? 'text-white' : 'text-live'
        }`}
      >
        {SHELL.serviceName}
      </span>
    </span>
  );
}
